import React from 'react';
import { Helmet } from 'react-helmet-async';

export const SeoMeta = ({ analysis }) => {
  if (!analysis) return null;

  const vehicle = analysis.vehicle || {};
  const make = vehicle.make || '';
  const model = vehicle.model || '';
  const registration = vehicle.registration || '';
  // Ensure we don't crash if these are missing
  const risk = analysis.risk_level || 'UNKNOWN';

  const schema = {
    "@context": "https://schema.org/",
    "@type": ["Vehicle", "Product"],
    "name": `${make} ${model} ${registration}`.trim(),
    "brand": {
      "@type": "Brand",
      "name": make
    },
    "model": model,
    "vehicleIdentificationNumber": vehicle.vin || '',
    "description": `Worthify report for ${make} ${model} with risk score ${risk}`,
  };

  const title = `${make} ${model} - Worthify Report`.trim();
  const description = `Worthify report for ${make} ${model} with risk score ${risk}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};
